import React, {FC} from 'react';
import {CChart} from "@coreui/react-chartjs";
import {getStyle} from "@coreui/utils";
import {colors} from "../../../../colorsForCharts/colorsForCharts";

interface IBarChartProps {
  labels: string[]
  data: {label: string, data: number[]}[]
}

const BarChart: FC<IBarChartProps> = ({labels, data}) => {
  return (
    <>
      <CChart
        type="bar"
        data={{
          labels: labels,
          datasets: data?.map((el, index) => ({
            label: el.label,
            backgroundColor: colors[index],
            borderColor: colors[index],
            data: el.data
          }))
          // labels: labels,
          // datasets: [
          //   {
          //     label: t(`analytics.${field}`),
          //     backgroundColor: 'rgba(255,99,132,0.75)',
          //     // @ts-ignore
          //     data: data,
          //   },
          // ],
        }}

        options={{
          plugins: {
            legend: {
              labels: {
                color: getStyle('--cui-body-color'),
              }
            }
          },
          scales: {
            x: {
              grid: {
                color: getStyle('--cui-border-color-translucent'),
              },
              ticks: {
                color: getStyle('--cui-body-color'),
              },
            },
            y: {
              grid: {
                color: getStyle('--cui-border-color-translucent'),
              },
              ticks: {
                color: getStyle('--cui-body-color'),
              },
            },
          },
        }}
      />
    </>
  );
};

export default BarChart;